import { Injectable } from '@angular/core';
import { DisplayItemTypeEnum } from '../../../../../lib/display/display-item/display-item-type.enum';
import { DisplayItem } from '../../../../../lib/display/display-item/display-item';
import { Subscription } from 'rxjs';
import { CardDispenserActionResult } from '../../../../../lib/rfid-card/card-dispenser-action-result';
import { CardDispenserBaseGridWorkflowService } from './card-dispenser-base-grid-workflow.service';

@Injectable()
export class CardDispenserGridWorkflowService extends CardDispenserBaseGridWorkflowService {

  private subscriptionCardRead: Subscription;

  private subscriptionAvailabilityChanged: Subscription;

  get displayItemType(): DisplayItemTypeEnum {
    return DisplayItemTypeEnum.CardDispenser;
  }

  show(displayItem: DisplayItem, context: any): void {
    super.show(displayItem, context);
    if (!this.cardDispenserService.isShowWaitRemoveCardDialog) {
      this.enableRfidCardScanned();
    }
  }

  hide(displayItem: DisplayItem, context: any): void {
    if (!this.cardDispenserService.isShowWaitRemoveCardDialog) {
      this.disabledRfidCardScanned();
    }
    super.hide(displayItem, context);
  }

  hideAll(): void {
    super.hideAll();
    this.disabledRfidCardScanned();
  }

  reset(): void {
    super.reset();
    if (this.cardDispenserService.cardCode) {
      this.cardDispenserService.releaseCardCustomer(true);
    } else if (this.cardDispenserService.inTransaction) {
      this.cardDispenserService.stopTransaction();
    }
  }

  get isEnableRfidCardScanned(): boolean {
    return this.subscriptionCardRead != null;
  }

  enableRfidCardScanned() {
    if (this.isEnableRfidCardScanned) {
      return;
    }

    if (!this.cardDispenserService.isAvailable) {
      this.loggingService.warning('CardDispenserGridWorkflowService. enableRfidCardScanned. Card dispenser not available');
      this.showCardDispenserNotAvailableAndBackToParentPage();
      return;
    }

    this.subscriptionCardRead = this.cardDispenserService.cardRead.subscribe((x: CardDispenserActionResult) => this.onCardRead(x));
    this.subscriptionAvailabilityChanged = this.cardDispenserService.availabilityChanged.subscribe(
      (x: CardDispenserActionResult) => this.onAvailabilityChanged(x));
    this.cardDispenserTakeCard(true);
  }

  disabledRfidCardScanned() {
    if (!this.isEnableRfidCardScanned) {
      return;
    }

    this.cardDispenserTakeCard(false);

    if (this.subscriptionCardRead) {
      this.subscriptionCardRead.unsubscribe();
      this.subscriptionCardRead = null;
    }

    if (this.subscriptionAvailabilityChanged) {
      this.subscriptionAvailabilityChanged.unsubscribe();
      this.subscriptionAvailabilityChanged = null;
    }
  }

  private cardDispenserTakeCard(value: boolean) {
    if (!this.cardDispenserService.isAvailable) {
      return;
    }

    try {
      if (value) {
        this.cardDispenserService.takeCardFromCustomer().catch(() => {
          this.loggingService.warning('CardDispenserGridWorkflowService. cardDispenserTakeCard. takeCardFromCustomer not started');
        });
      } else {
        if (!this.cardDispenserService.cardCode) {
          this.cardDispenserService.stopTakeCardFromCustomer();
        }
      }
    } catch {
      this.loggingService.warning('CardDispenserGridWorkflowService. cardDispenserTakeCard. Card already taken');
    }
  }

  showErrorMessage(title: string, error: any): void {
    super.showErrorMessage(title, error);
    if (this.cardDispenserService.cardCode && this.cardDispenserService.isAvailable) {
      this.cardDispenserService.releaseCardCustomerAndContinueTakingCardFromCustomer();
    }
  }

  onCardRead(cardDispenserActionResult: CardDispenserActionResult) {
    this.userActivity();
    if (!this.context || !cardDispenserActionResult || cardDispenserActionResult.isFailed || !cardDispenserActionResult.barcode) {
      return;
    }
    this.displayGridWorkflowService.updateContext({
      rfidCardCode: cardDispenserActionResult.barcode
    });

    this.navigateToUrlOrNavigationItem(this.displayItem);
  }

  onAvailabilityChanged(cardDispenserActionResult: CardDispenserActionResult) {
    if (!cardDispenserActionResult.isAvailable) {
      this.showCardDispenserNotAvailableAndBackToParentPage();
    }
  }

  fillExternalApiRequestData(requestData: Map<string, any>, context: any) {
    if (context.rfidCardCode) {
      requestData.set('barcode', context.rfidCardCode);
    }
  }
}
